import type { Chat, FilterQuery } from '@ztechapps/common.contract'
import { ChatStatusEnum } from '@ztechapps/common.contract'

export const buildConversationFilter = (input: string, filter?: FilterQuery<Chat>): FilterQuery<Chat> => ({
  $or: [
    { code: { $regex: input, $options: 'i' } },
    { subject: { $regex: input, $options: 'i' } },
    { 'sender.profile.name': { $regex: input, $options: 'i' } },
    { 'sender.profile.email': { $regex: input, $options: 'i' } },
  ],
  // Excluded by default — a caller that already sets its own `status` filter overrides this.
  status: { $ne: ChatStatusEnum.Cancelled },
  ...filter,
})
